module.exports = __webpack_public_path__ + "empty-cart.aa012412a3668eb7151b6731c716a428.svg";